<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_318" data-name="Group 318" transform="translate(-594.989 -280.254)">
    <circle id="Ellipse_196" data-name="Ellipse 196" cx="35.201" cy="35.201" r="35.201" transform="translate(594.989 280.254)" fill="#fff"/>
    <g id="Group_274" data-name="Group 274" transform="translate(-2267.717)">
      <path id="Path_350" data-name="Path 350" d="M2906.632,299.658v2.455a2.778,2.778,0,0,0,5.556,0V296.09a2.778,2.778,0,0,0-5.556,0Z" fill="#1a1818"/>
      <path id="Path_351" data-name="Path 351" d="M2885.7,299.161h5.288v-4.937a2.644,2.644,0,0,0-5.288.039Z" fill="#1a1818"/>
      <path id="Path_352" data-name="Path 352" d="M2892.644,294.119c0,.012,0,.025,0,.039v5.031h5.431v-6.644a2.718,2.718,0,0,0-5.435,0Z" fill="#1a1818"/>
      <path id="Path_353" data-name="Path 353" d="M2905.276,294.026v7.793a.854.854,0,0,1-.013.187v.133a2.876,2.876,0,0,1-3.181,2.727,2.992,2.992,0,0,1-2.58-3.034v-7.98a2.886,2.886,0,0,1,3.181-2.874A3.015,3.015,0,0,1,2905.276,294.026Z" fill="#1a1818"/>
      <path id="Path_354" data-name="Path 354" d="M2898.249,292.8v7.564a.8.8,0,0,1-.013.182v.13a2.792,2.792,0,0,1-3.088,2.646,2.9,2.9,0,0,1-2.5-2.945v-7.746a2.8,2.8,0,0,1,3.088-2.789A2.927,2.927,0,0,1,2898.249,292.8Z" fill="#1a1818"/>
      <path id="Path_355" data-name="Path 355" d="M2891,294.435V301.6a.757.757,0,0,1-.012.172v.123a2.645,2.645,0,0,1-2.925,2.507,2.75,2.75,0,0,1-2.371-2.789v-7.336a2.652,2.652,0,0,1,2.924-2.642A2.772,2.772,0,0,1,2891,294.435Z" fill="#1a1818"/>
      <g id="Group_273" data-name="Group 273">
        <path id="Path_356" data-name="Path 356" d="M2898.423,303.409c-.1.1-.2.2-.31.293a4.053,4.053,0,0,1-2.647.978,4.324,4.324,0,0,1-.466-.026,2.046,2.046,0,0,0-4.087.156,3.916,3.916,0,0,1-2.553.944,4.243,4.243,0,0,1-.449-.025,4.1,4.1,0,0,1-3.561-4.119v-.9h-1.179v13.726a.408.408,0,0,1,.026.107c.253,2.166,2.074,4.708,3.919,6.621a17.46,17.46,0,0,0,2.709,2.343c.009.005.008.018.017.027a.149.149,0,0,1,.023.015.554.554,0,0,1,.245.457V341.08h17.532V324.03a.535.535,0,0,1,.183-.4,13.453,13.453,0,0,0,4.491-8.894,3.438,3.438,0,0,0,.061-.578v-9.091a8.364,8.364,0,0,0-9.992,1.308,3.987,3.987,0,0,1-2.7-1.068,8.335,8.335,0,0,1-4.964,3.136,6.063,6.063,0,0,1-1.1.1l-3.381.019.022,1.248a12.458,12.458,0,0,1,11.795,12.653v1.516c.019.019-1.439.01-1.449,0v-1.516a11.312,11.312,0,0,0-11.3-11.3.546.546,0,0,1-.546-.544v-2.976a.541.541,0,0,1,.16-.383.547.547,0,0,1,.386-.161l4.234,0c.034,0,.079-.01.115-.011a5.229,5.229,0,0,0,.808-.082,6.938,6.938,0,0,0,4.513-2.587Z" fill="#1a1818"/>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_02_02.vue